import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createIPAQSFAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface IPAQSFAssessmentResult {
  id: string;
  assessmentType: 'physical';
  scores: {
    overall: number;
    categories: {
      name: string;
      score: number;
      description: string;
    }[];
    ipaqSf: {
      totalMET: number;
      activityLevel: string;
      sittingHours: number;
      sittingLevel: string;
    };
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations?: any[];
  };
  createdAt: string;
}

const IPAQSFAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as IPAQSFAssessmentResult;

  // Handle navigation in useEffect to avoid calling navigate during render
  useEffect(() => {
    if (!assessmentResult) {
      // If no result data, redirect to learn page
      navigate('/panel/learn/');
      return;
    }
  }, [assessmentResult, navigate]);

  // Don't render anything if no assessment result
  if (!assessmentResult) {
    return null;
  }

  // Create configuration using the template system
  const config = createIPAQSFAssessmentConfig(assessmentResult);

  // Use the template component
  return <AssessmentCompletionTemplate config={config} />;
};

export default IPAQSFAssessmentCompletionPage;


